import splitioNode from './node'
import splitioBrowser from './browser'

export default process.browser ? splitioBrowser : splitioNode
